const enum AutorizarSolicitacaoStatusEnum {
  Autorizado = 'autorizado',
  Parcial = 'parcial',
  Cancelado = 'cancelador',
  EmAnalise = 'emAnalise',
}

export default AutorizarSolicitacaoStatusEnum
